export const apiUrl = process.env.VUE_APP_API_URL;
export const s3BucketRegion = process.env.VUE_APP_S3_BUCKET_REGION;
export const s3BucketName = process.env.VUE_APP_S3_BUCKET_NAME;
export const cognitoIdentityPoolId = process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID;
export const gitSha = process.env.VUE_APP_COMMIT_SHA;
